import { alpha, styled } from '@mui/material/styles';
import { Reaction } from 'features/room-reactions/types';
import { EMOJI_ICONS } from 'features/room-reactions/constants';

const Container = styled('span')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  borderRadius: '50%',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 4,
  width: 32,
  height: 32,
}));

const Emoji = styled('img')({
  width: '100%',
  height: '100%',
});

type ReactionBadgeProps = {
  reaction: Reaction;
};

export const ReactionBadge = ({ reaction }: ReactionBadgeProps) => (
  <Container>
    <Emoji src={EMOJI_ICONS[reaction]} alt={reaction} />
  </Container>
);
